import { FETCH_SITES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SITES:
			return action.payload;
		default:
			return state;
	}
};
